import baseTheme from '../baseTheme';
export var MuiInputBase = {
    input: {
        padding: '14px 1px 13px',
        lineHeight: 1.35,
        fontSize: baseTheme.typography.pxToRem(16),
        boxSizing: 'border-box',
        height: 'auto',
    },
};
//# sourceMappingURL=MuiInputBase.js.map